module.exports = __webpack_public_path__ + "static/media/thumb-down.6f4b425a.png";